'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { CoachesResponse } from '@insta-club/models';
import Image from 'next/image';
import Link from 'next/link';
import ContentWrapper from 'src/libs/components/common/contentWrapper';
import { ChevronIcon } from 'src/libs/components/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSWR from 'swr';

function Coaches() {
    const { data, isLoading } = useSWR<CoachesResponse>(ApiKeys.COACHES, (url: string) =>
        fetcher(url, 'dashboard', 'GET')
    );

    return (
        <>
            {isLoading ? (
                <ContentWrapper title='مدرس های اینستا کلاب'>
                    <Swiper
                        style={{ overflow: 'visible', overflowX: 'clip' }}
                        slidesPerView={'auto'}
                        spaceBetween={24}
                        slidesOffsetBefore={24}
                        slidesOffsetAfter={24}
                    >
                        {Array.from({ length: 10 }, (_, index) => {
                            return (
                                <SwiperSlide key={index} style={{ width: 216 }}>
                                    <div className='relative mt-4 mr-[24px] animate-pulse rounded-xl bg-gray-100'>
                                        <div className='absolute right-[10px] bottom-0 z-10 h-[133px] w-[103px] rounded-md bg-gray-300' />
                                        <div className='flex flex-col items-end px-[17px] py-[22px]'>
                                            <div className='mb-9 h-4 w-24 rounded-md bg-gray-300' />
                                            <div className='flex items-center space-x-2 rtl:space-x-reverse'>
                                                <div className='h-4 w-16 rounded-md bg-gray-300' />
                                                <div className='h-4 w-4 rounded-full bg-gray-300' />
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </ContentWrapper>
            ) : (
                !!data?.length && (
                    <ContentWrapper title='مدرس های اینستا کلاب'>
                        <Swiper
                            className='mt-8'
                            style={{ overflow: 'visible', overflowX: 'clip' }}
                            slidesPerView={'auto'}
                            spaceBetween={24}
                            slidesOffsetBefore={24}
                            slidesOffsetAfter={24}
                        >
                            {data?.map((item) => {
                                return (
                                    <SwiperSlide key={item.username} style={{ width: 216 }}>
                                        <Link href={`/videos?coach_id=${item.id}`}>
                                            <div className='bg-primary-50 relative flex justify-end rounded-xl px-[17px] py-[22px]'>
                                                <div className='absolute right-[10px] bottom-0 z-10 h-[133px] w-[103px] overflow-hidden rounded-md'>
                                                    <Image
                                                        src={item.image}
                                                        alt='coach'
                                                        fill
                                                        sizes='103px'
                                                        className='object-cover'
                                                    />
                                                </div>
                                                <div>
                                                    <span className='mb-5 block text-sm font-semibold text-gray-700'>
                                                        {item.first_name} {item.last_name}
                                                    </span>
                                                    <span className='text-primary-500 flex items-center text-sm font-semibold'>
                                                        آموزش ها
                                                        <ChevronIcon className='mr-2' />
                                                    </span>
                                                </div>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </ContentWrapper>
                )
            )}
        </>
    );
}

export default Coaches;

